<template>
  <div class="search_row mb-5 px-8">
    <p>{{ title }}</p>
    <v-row no-gutters class="date_filter">
      <v-col class="d-flex pr-4" cols="6">
        <button type="button" class="active_date" :class="{ active: value.active === 'today' }" @click="dateSet('today')">오늘</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'week1' }" @click="dateSet('week1')">1주일</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'month1' }" @click="dateSet('month1')">1개월</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'month3' }" @click="dateSet('month3')">3개월</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'month6' }" @click="dateSet('month6')">6개월</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'year1' }" @click="dateSet('year1')">1년</button>
      </v-col>
      <v-col class="d-flex" cols="6">
        <date-picker v-model="selectedDate.startDate" :max="selectedDate.endDate" @fieldChanged="removeActiveClass"></date-picker>
        <span class="mark">~</span>
        <date-picker v-model="selectedDate.endDate" :min="selectedDate.startDate" @fieldChanged="removeActiveClass"></date-picker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/common/DatePicker';
export default {
  name: 'DateFilter',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          startDate: '',
          endDate: '',
          active: '',
        };
      },
    },
    title: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      calendarMenu1: false,
      calendarMenu2: false,
      date: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    selectedDate: {
      handler(val) {
        if (val.startDate === '' && val.endDate === '') this.removeActiveClass();
      },
      deep: true,
    },
  },
  methods: {
    dateSet(period) {
      this.value.active = period;
      const today = new Date();
      const bDay = new Date();
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      const year = today.getFullYear();
      const monthIndex = today.getMonth();
      const month = months[monthIndex] < 10 ? `0${months[monthIndex]}` : months[monthIndex];
      const date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
      let sDate = '';
      let eDate = '';
      // let sDateType1 = '';
      // let eDateType1 = '';
      let byear, bmonthIndex, bmonth, bdate;

      switch (period) {
        case 'today':
          sDate = `${year}-${month}-${date}`;
          // sDateType1 = `${year}.${month}.${date}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
        case 'week1':
          bDay.setDate(today.getDate() - 7);
          byear = bDay.getFullYear();
          bmonthIndex = bDay.getMonth();
          bmonth = months[bmonthIndex] < 10 ? `0${months[bmonthIndex]}` : months[bmonthIndex];
          bdate = bDay.getDate() < 10 ? `0${bDay.getDate()}` : bDay.getDate();

          sDate = `${byear}-${bmonth}-${bdate}`;
          // sDateType1 = `${byear}.${bmonth}.${bdate}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
        case 'month1':
          bDay.setMonth(today.getMonth() - 1);
          byear = bDay.getFullYear();
          bmonthIndex = bDay.getMonth();
          bmonth = months[bmonthIndex] < 10 ? `0${months[bmonthIndex]}` : months[bmonthIndex];
          bdate = bDay.getDate() < 10 ? `0${bDay.getDate()}` : bDay.getDate();

          sDate = `${byear}-${bmonth}-${bdate}`;
          // sDateType1 = `${byear}.${bmonth}.${bdate}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
        case 'month3':
          bDay.setMonth(today.getMonth() - 3);
          byear = bDay.getFullYear();
          bmonthIndex = bDay.getMonth();
          bmonth = months[bmonthIndex] < 10 ? `0${months[bmonthIndex]}` : months[bmonthIndex];
          bdate = bDay.getDate() < 10 ? `0${bDay.getDate()}` : bDay.getDate();

          sDate = `${byear}-${bmonth}-${bdate}`;
          // sDateType1 = `${byear}.${bmonth}.${bdate}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
        case 'month6':
          bDay.setMonth(today.getMonth() - 6);
          byear = bDay.getFullYear();
          bmonthIndex = bDay.getMonth();
          bmonth = months[bmonthIndex] < 10 ? `0${months[bmonthIndex]}` : months[bmonthIndex];
          bdate = bDay.getDate() < 10 ? `0${bDay.getDate()}` : bDay.getDate();

          sDate = `${byear}-${bmonth}-${bdate}`;
          // sDateType1 = `${byear}.${bmonth}.${bdate}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
        case 'year1':
          bDay.setFullYear(today.getFullYear() - 1);
          byear = bDay.getFullYear();
          bmonthIndex = bDay.getMonth();
          bmonth = months[bmonthIndex] < 10 ? `0${months[bmonthIndex]}` : months[bmonthIndex];
          bdate = bDay.getDate() < 10 ? `0${bDay.getDate()}` : bDay.getDate();

          sDate = `${byear}-${bmonth}-${bdate}`;
          // sDateType1 = `${byear}.${bmonth}.${bdate}`;
          eDate = `${year}-${month}-${date}`;
          // eDateType1 = `${year}.${month}.${date}`;
          break;
      }

      this.selectedDate.startDate = sDate;
      this.selectedDate.endDate = eDate;
      // document.getElementById(this.selectedDate.startDate).value = sDateType1;
      // document.getElementById(this.selectedDate.endDate).value = eDateType1;
    },
    removeActiveClass() {
      this.value.active = '';
    },
  },
};
</script>

<style scoped></style>
